import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private apiService = inject(ApiService);
  private http = inject(HttpClient);
  private readonly apiUrl: string = environment.apiUrl;

  getBusinessCount(body: object): Observable<any> {
    return this.apiService.store('dashboard/business-counts', body);
  }

  getWorkerCount(body: object): Observable<any> {
    return this.apiService.store('dashboard/worker-counts', body);
  }

  getReservationsCount(data: object): Observable<any> {
    return this.apiService.post(`dashboard/reservation-counts`, data);
  }
  getReservationReservariosCountxcsv(data: object): Observable<any> {
    return this.http.post(
      `${this.apiUrl}report/getReservationsByFiltersCsvDashboard`,
      data,
      {
        responseType: 'blob' as 'json',
      }
    );
  }

  getReservationsActiveCount(data: object): Observable<any> {
    return this.apiService.post(`dashboard/active-reservation-counts`, data);
  }
  getReservationReservariosMapaCalorCountsCSV(data: object): Observable<any> {
    return this.http.post(
      `${this.apiUrl}report/getBusiestReservedWorkplacesCSVDashboard`,
      data,
      {
        responseType: 'blob' as 'json',
      }
    );
  }

  getReservationsHeatMapCSV(data: object): Observable<any> {
    return this.http.post(
      `${this.apiUrl}report/getBusiestReservedFloorsCSVDashboard`,
      data,
      {
        responseType: 'blob' as 'json',
      }
    );
  }
  getReservationsGraaphic(data: object): Observable<any> {
    return this.apiService.post(`dashboard/graphic-reservation-counts`, data);
  }
  x(data: object): Observable<any> {
    return this.http.post(
      `${this.apiUrl}report/getReservationsByFiltersCsvDashboard`,
      data,
      {
        responseType: 'blob' as 'json',
      }
    );
  }
  getReservationsHeatMap(data: object): Observable<any> {
    return this.apiService.post(`dashboard/heat-reservation-counts`, data);
  } //
  getReservationsHeatMapImage(data: object): Observable<any> {
    return this.apiService.post(`dashboard/heat-places-counts`, data);
  } //dashboard/heat-places-counts
}
